/* global window */
import bugsnagJs from 'bugsnag-js'
import { BUGSNAG_API_KEY } from './settings'

export const bugsnag = bugsnagJs({
  apiKey: BUGSNAG_API_KEY,
  releaseStage: process.env.STAGING_ENV || 'production',
  NotifyReleaseStages: ['production', 'staging', 'staging_v1', 'staging_v2', 'staging_v3', 'staging_v4'],
  beforeSend: function (report) {
    // inspectlet is causing issues
    if (
      report.errorMessage === '_isMatchingDomain is not defined' ||
      report.errorMessage.indexOf("Failed to execute 'postMessage' on 'Window'") >= 0
    ) {
      report.groupingHash = report.errorClass + report.errorMessage
    }
  }
})

if (typeof window !== 'undefined') {
  window.Bugsnag = bugsnag
}

export const initBugSnag = railsContext => {
  bugsnag.user = {
    id: railsContext.currentUserId,
    name: railsContext.currentUserName,
    email: railsContext.currentUserEmail
  }
}

export default bugsnag
